import { createContext } from 'react';

import { IBAuth0RoleDetail } from '@totem/components/services/remoteAccess/auth0role/details/types';
import { Auth0UserItem } from '@totem/components/services/remoteAccess/auth0users/details/types';

interface Context {
  loading: boolean;
  role: IBAuth0RoleDetail | null;
  users: Auth0UserItem[];
  usersLoading: boolean;
  onRefresh: () => void;
}

export default createContext<Context>({
  loading: false,
  role: null,
  users: [],
  usersLoading: false,
  onRefresh: () => {},
});
